import React from 'react';
import { CheckIcon, MoveRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { VignetteFrame } from './VignetteFrame';
export function ReviveVignette() {
  return <VignetteFrame label="Reactivation" timestamp="Demonstrative" data-id="element-424" data-mp="2q7uf2mkdagg">
      <div className="rounded-xl border border-white/10 bg-ink-700 px-4 py-3" data-id="element-425" data-mp="2s2kevcozsre">
        <p className="text-sm font-semibold text-white/70" data-id="element-426" data-mp="7qm4eq7q6uh4">Lead from Mar 2026</p>
        <p className="mt-1 text-xs text-white/40" data-id="element-427" data-mp="cn2wfvi1pszh">No contact since</p>
      </div>

      <Reveal delay={0.25} offset={8} className="flex justify-center py-3" data-id="element-428" data-mp="hmffe55sqfws">
        <span className="flex h-8 w-8 items-center justify-center rounded-full border border-brand/30 bg-brand/10" data-id="element-429" data-mp="mdxjv3712ymi">
          <MoveRightIcon className="h-4 w-4 rotate-90 text-brand" aria-hidden="true" data-id="element-430" data-mp="qg279k6vuz0p" />
        </span>
      </Reveal>

      <Reveal delay={0.45} offset={10} className="rounded-xl border border-brand/30 bg-brand/10 px-4 py-3" data-id="element-431" data-mp="vfomfz69upc5">
        <div className="flex items-start gap-3" data-id="element-432" data-mp="10bm3k7pczzpz">
          <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand" data-id="element-433" data-mp="2g1rh4pvu4roh">
            <CheckIcon className="h-3 w-3 text-ink-900" aria-hidden="true" data-id="element-434" data-mp="2b1d5yyyxt1m8" />
          </span>
          <div data-id="element-435" data-mp="271unsayi34n3">
            <p className="text-sm font-semibold text-white" data-id="element-436" data-mp="271md8ppuobf2">Re-engaged today, replied</p>
            <p className="mt-1 text-xs text-white/60" data-id="element-437" data-mp="222rqjcori2po">Tour booked Thursday</p>
          </div>
        </div>
      </Reveal>
    </VignetteFrame>;
}